import { render } from "./ApiManager.vue?vue&type=template&id=1d863d14"
import script from "./ApiManager.vue?vue&type=script&lang=js"
export * from "./ApiManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__